<ui-graph
  [id]="(userCardService.user$ | async)?.uuid"
  type="user"
  class="user-graph"
></ui-graph>
